<template>
    <home endpoint="ssr" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'ssr',
  components: {
    home,
  },
  data  () {
    return {
      params: {
        fields: [
          {name: 'SSRCode', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'FeeCode', relation: 'fee', optionLabels: 'Name',
            editor: 'select', label: 'Cargo', id: 'FeeCode', addBlank: true},
          {name: 'InWebSales', label: 'Venta web', editor: 'checkbox'},
          {name: 'Category', label: 'Categoría', editor: 'select',
            options: [
              {value: 'BAGGAGE', label: 'Bodega'},
              {value: 'CABIN', label: 'Cabina'},
              {value: 'UPGRADE', label: 'Mejora'},
              {value: 'CHECKIN', label: 'Check-in'},
              {value: 'OTHER', label: 'Otro'},
            ], addBlank: true},
          {name: 'Pieces', label: 'Piezas', editor: 'number'},
          {name: 'Icon', label: 'Ícono'},
          {name: 'I18nKey', label: 'Clave i18n'},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'},
          {name: 'RoutePolicies', editor: [], hideFromList: true, label: 'Políticas por mercado',
            rowFields: [
              {name: 'MarketType', label: 'Mercado', editor: 'select', required: true, defValue: 0,
                options: [
                  {value: 0, label: 'Local'},
                  {value: 1, label: 'Internacional'},
                ], columns: 2},
              {name: 'MaxWeight', label: 'Peso máx.', editor: 'number', columns: 2},
              {name: 'WeightUnit', label: 'Unidad peso', defValue: 'KG', columns: 1},
              {name: 'MaxDimHeight', label: 'Alto', editor: 'number', columns: 1},
              {name: 'MaxDimWidth', label: 'Ancho', editor: 'number', columns: 1},
              {name: 'MaxDimLength', label: 'Profundidad / lineal', editor: 'number', columns: 2},
              {name: 'DimUnit', label: 'Unidad dim.', defValue: 'CM', columns: 1},
              {name: 'AllowExcess', label: 'Permite exceso', editor: 'checkbox', columns: 1},
            ]},
          ],
        title: 'SSRs',
        title2: 'ssr',
        primaryKey: 'SSRCode',
        modalClass: 'modal-large',
      }
    }
  },
}
</script>
